// API routes for inventory management
export const INVENTORY_API = {
  INVENTORY_ITEMS: 'inventory_items',
  PURCHASE_ORDERS: 'purchase_orders',
  INVENTORY_TRANSACTIONS: 'inventory_transactions',
  APPROVALS: 'inventory_approvals',
  SUPPLIERS: 'inventory_suppliers',
  INVENTORY_CATEGORIES: 'inventory/categories',
  INVENTORY_PURCHASES: 'inventory/purchases'
}

// API route keys for actions
export const ROUTE_KEYS = {
  READ: 'read',
  CREATE: 'create',
  UPDATE: 'update',
  DELETE: 'delete',
  COUNT: 'count',
  AGGREGATE: 'aggregate'
}

// Inventory item status constants
export const STOCK_STATUS = {
  HEALTHY: 'Healthy',
  LOW_STOCK: 'Low Stock',
  OUT_OF_STOCK: 'Out of Stock',
  OVER_STOCK: 'Over Stock'
}

// Expiry status constants
export const EXPIRY_STATUS = {
  VALID: 'Valid',
  EXPIRING_SOON: 'Expiring Soon', // Within 90 days
  EXPIRED: 'Expired'
}

// Color constants for UI
export const COLORS = {
  PRIMARY: '#1890ff',
  SUCCESS: '#52c41a',
  WARNING: '#faad14',
  ERROR: '#f5222d',
  INFO: '#13c2c2',
  LOW_STOCK: '#faad14',
  EXPIRED: '#f5222d',
  EXPIRING_SOON: 'volcano',
  NEAR_EXPIRY: '#fa8c16',
  HEALTHY_STOCK: '#52c41a',
  OVER_STOCK: '#722ed1',
  HEALTHY: 'green'
}

// Dashboard time period options
export const DASHBOARD_PERIODS = [
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 3 months' },
  { value: '180d', label: 'Last 6 months' },
  { value: '365d', label: 'Last 12 months' }
]

// Inventory tracking method options
export const TRACKING_METHODS = [
  { label: 'Individual Units', value: 'individualUnits' },
  { label: 'Whole Packs Only', value: 'wholePacksOnly' },
  { label: 'Partial Packs', value: 'partialPacks' }
]

// Form field validation rules
export const VALIDATION_RULES = {
  required: { required: true, message: 'This field is required' },
  numberRequired: { required: true, type: 'number', message: 'Please enter a valid number' },
  minZero: { type: 'number', min: 0, message: 'Value must be greater than or equal to 0' },
  minOne: { type: 'number', min: 1, message: 'Value must be greater than or equal to 1' },
  email: { type: 'email', message: 'Please enter a valid email address' },
  phone: { pattern: /^(\+\d{1,3}[-\s]?)?\d{9,15}$/, message: 'Please enter a valid phone number' },
  nappiCode: { pattern: /^\d{6,12}$/, message: 'NAPPI Code must be 6-12 digits' }
}

// Table pagination settings
export const DEFAULT_PAGE_SIZE = 10
export const PAGE_SIZE_OPTIONS = ['10', '25', '50', '100']

// Date format settings
export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const DISPLAY_DATE_FORMAT = 'DD MMM YYYY'
export const DISPLAY_DATE_TIME_FORMAT = 'DD MMM YYYY HH:mm'

// Inventory categories with icons
export const INVENTORY_CATEGORIES = [
  { value: 'Consumables', icon: 'box' },
  { value: 'Equipment', icon: 'stethoscope' },
  { value: 'Medication', icon: 'pills' },
  { value: 'PPE', icon: 'head-side-mask' },
  { value: 'Laboratory', icon: 'flask' },
  { value: 'Surgical', icon: 'scalpel' },
  { value: 'Dental', icon: 'tooth' },
  { value: 'Office Supplies', icon: 'paperclip' }
]

// Storage locations
export const STORAGE_LOCATIONS = [
  'Pharmacy',
  'Main Storage',
  'Emergency Department',
  'Supply Room A',
  'Supply Room B',
  'Equipment Room',
  'Laboratory Storage',
  'Refrigerator',
  'Controlled Substances Cabinet',
  'General Storage'
]

// Alert thresholds
export const ALERT_THRESHOLDS = {
  LOW_STOCK_PERCENT: 25, // Alert when stock is below 25% of min level
  EXPIRY_WARNING_DAYS: 90, // Alert when item is within 90 days of expiry
  CRITICAL_EXPIRY_DAYS: 30 // Critical alert when item is within 30 days of expiry
}

// Status badges
export const STATUS_BADGES = {
  ACTIVE: { color: '#52c41a', text: 'Active' },
  INACTIVE: { color: '#f5222d', text: 'Inactive' },
  LOW_STOCK: { color: '#faad14', text: 'Low Stock' },
  EXPIRED: { color: '#f5222d', text: 'Expired' },
  EXPIRING_SOON: { color: '#fa8c16', text: 'Expiring Soon' },
  OUT_OF_STOCK: { color: '#f5222d', text: 'Out of Stock' },
  OVER_STOCK: { color: '#722ed1', text: 'Over Stock' }
}
